<template>
	<div id="app">
		<div class="o-wrap">
			<div style="display: flex;align-items: center;">
				<el-page-header content="视频管理" />
				<el-button class="add-btns_video" style="margin-left: 20px;" type="primary" @click="jumpVideo" plain >发布视频</el-button>
			</div>
			<div class="spListCount">
				<div class="spBoxs" v-for="(item,index) in list" :key="item.id">
					<div class="picBox">
						<img :src="item.url" alt="">
						{{item.title}}
					</div>
					<div class="spText" v-if="item.text2 == '' || item.text2 == null"  @click="binding(item.id,item.title,item.name)">
						{{item.text}}
						<i class="el-icon-edit"></i>
					</div>
					<div class="spName" v-else>
						
						<div class="name">
							<!-- <el-tooltip :content="item.text2" placement="bottom" effect="light">
								
								<div slot="content"></div>
							</el-tooltip> -->
							{{item.text2}}
						</div>
						<div class="changeBind" @click="changeBinding(item)" v-if="item.name != 'zlqt'">
							取消授权
							<i class="el-icon-circle-close"></i>
						</div>
					</div>
				</div>
			</div>
			<el-table :data="tableData" border>
				<el-table-column width="200px" fixed prop="logo" label="视频封面" >
					<template slot-scope="scope">
						<img :src="ingUl+scope.row.thumb" :onerror="imgSrc" alt="">
					</template>
				</el-table-column>
				<el-table-column  label="名称/简介">
					<!-- prop="name" -->
					<template class="detailCounts" slot-scope="scope">
						<div class="title">
							{{scope.row.name}}
						</div>
						<div class="details">
							{{scope.row.description}}
						</div>
					</template>
				</el-table-column>
				<el-table-column  label="其他平台发布情况" width="600px">
					<template class="xsqkBox"  slot-scope="scope">
						<span v-if="scope.row.sendKwai" style="margin-right: 5px;">
							快手<el-switch v-model="scope.row.sendKwai" disabled></el-switch>
						</span>
						<span class="" v-else style="margin-right: 5px;">
							快手	<el-switch v-model="scope.row.sendKwai" disabled></el-switch>
						</span>
						<span v-if="scope.row.sendTiktok" style="margin-right: 5px;">
							抖音<el-switch v-model="scope.row.sendTiktok" disabled></el-switch>
						</span>
						<span class="" v-else style="margin-right: 5px;">
							抖音<el-switch v-model="scope.row.sendTiktok" disabled></el-switch>
						</span>
						<!-- <span v-if="scope.row.sendBili" style="margin-right: 5px;">
							哔哩哔哩<el-switch v-model="scope.row.sendBili" disabled></el-switch>
						</span>
						<span class="" v-else style="margin-right: 5px;">
							哔哩哔哩<el-switch v-model="scope.row.sendBili" disabled></el-switch>
						</span> -->
						<span v-if="scope.row.sendXdsb" style="margin-right: 5px;">
							消毒设备<el-switch v-model="scope.row.sendXdsb" disabled></el-switch>
						</span>
						<span class="" v-else style="margin-right: 5px;">
							消毒设备<el-switch v-model="scope.row.sendXdsb" disabled></el-switch>
						</span>
						<span v-if="scope.row.sendZlqt" style="margin-right: 5px;">
							中链企通<el-switch v-model="scope.row.sendZlqt" disabled></el-switch>
						</span>
						<span class="" v-else style="margin-right: 5px;">
							中链企通<el-switch v-model="scope.row.sendZlqt" disabled></el-switch>
						</span>
						<span v-if="scope.row.sendCommerce" style="margin-right: 5px;">
							商会<el-switch v-model="scope.row.sendCommerce" disabled></el-switch>
						</span>
						<span class="" v-else style="margin-right: 5px;">
							商会<el-switch v-model="scope.row.sendCommerce" disabled></el-switch>
						</span>
					</template>
					<!-- <div>
						抖音
						<el-switch
						  v-model="value1"
						  disabled>
						</el-switch>
					</div>
					<div>
						抖音
						<el-switch
						  v-model="value1"
						  disabled>
						</el-switch>
					</div>
					<el-switch
					  v-model="value2"
					  disabled>
					</el-switch> -->
					
				</el-table-column>
				<el-table-column label="审核状态"  width="150px">
					<template slot-scope="scope">
						<template  v-if="scope.row.status == '0'">
							审核中
						</template>
						<template  v-if="scope.row.status == '1'">
							发布成功
						</template>
						<template  v-if="scope.row.status == '2'">
							待发布
						</template>
						<template  v-if="scope.row.status == '3'">
							已驳回
						</template>
						<!-- <el-button type="text" size="small" @click="handleJump(scope.row)">查看</el-button> -->
					</template>
				</el-table-column>
				<el-table-column label="操作"  width="150px">
					<template slot-scope="scope">
						<!-- <el-popconfirm title="确认下架吗？" @confirm="handleDel(scope.row)">
							<el-button type="text" size="small" slot="reference">下架</el-button>
						</el-popconfirm> -->
						<el-button type="text" size="small" @click="handleJump(scope.row)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog  width="476px" :visible.sync="dialogTab" :before-close="handleCloseB">
				<div class="dialogBox">
					<div class="title">
						{{title}}账号绑定
					</div>
					<div class="forms">
						<el-form ref="forms" :model="forms" label-width="80px">
						  <el-form-item label="账号">
						    <el-input v-model="forms.phone" placeholder="请输入账号"></el-input>
						  </el-form-item>
						  <el-form-item label="密码">
						    <el-input v-model="forms.password" placeholder="请输入密码"></el-input>
						  </el-form-item>
						  <el-form-item class="onBtn">
						      <el-button type="primary" @click="onSubmit(name)">绑定</el-button>
						  </el-form-item>
						</el-form>
					</div>
				</div>
			</el-dialog>
			<el-pagination layout="prev, pager, next" :total="pagination.totalPage"  :hide-on-single-page="pagination.hide"
				:page-size="pagination.pageSize" :current-page="pagination.pageNumber" @current-change="currentChange">
			</el-pagination>
		</div>
	</div>
</template>
<script>
import { Header } from 'element-ui'
	import Qs from 'qs'
	import Axios from 'axios'
	export default {
		data() {
			return {
				ingUl:this.$store.state.VIDEO_URL,
				tableData:[],
				ptList:[],
				imgSrc: 'this.src="' + require('../../assets/img/mr.jpg') + '"',
				pagination:{
					hide: true,
					totalNum:'',
					pageSize:20,
					currentPage:'',
					pageNumber:1
				},
				dialogTab:false,
				title:'',
				forms:{
					userId:this.$store.state.USER_ID, //用户ID
					phone: "", //手机号
					type: "", //默认 xdsb, xdsb: 消毒设备网, com: 商会
					password: "" //密码
				},
				list: [{
						id: '1',
						title: '抖音',
						name:'tiktok',
						url: require('@/assets/img/dy.png'),
						text: '绑定账号',
						text2:''
					},
					{
						id: '2',
						title: '快手',
						name:'kwai',
						url: require('@/assets/img/ks.png'),
						text: '绑定账号',
						text2:''
					},
					// {
					// 	id: '3',
					// 	title: '',
					// 	name:'bili',
					// 	url: require('@/assets/img/b.png'),
					// 	text: '绑定账号',
					// 	text2:''
					// },
					{
						id: '4',
						title: '中链',
						name:'zlqt',
						url: require('@/assets/img/zl.png'),
						text: '绑定账号',
						text2:''
					},
					{
						id: '5',
						title: '消毒',
						name:'xdsb',
						url: require('@/assets/img/xd.png'),
						text: '绑定账号',
						text2:''
					},
					{
						id: '6',
						title: '商会',
						name:'com',
						url: require('@/assets/img/sh.png'),
						text: '绑定账号',
						text2:''
					},
				],
			}

		},
		computed: {
			
		},
		created() {
			this.getVideList()
			this.getzt()
		},
		methods: {
			getzt(){
				this.$axios.get(this.$store.state.VIDEO_URL+'/api/getAuthList?userId='+this.$store.state.USER_ID+'&type=').then(data => {
					let datas = data.data
					if(data.code == "1000"){
						// this.list[0].text2 = datas.authTiktok.nickName
						// this.list[1].text2 = datas.authKwai.nickName
						// this.list[2].text2 = datas.authBili.nickName
						// this.list[3].text2 = datas.userName
						// this.list[4].text2 = datas.authXdsb.nickName
						// this.list[5].text2 = datas.authCommerce.nickName
						this.list[0].text2 = datas.authTiktok.nickName
						this.list[1].text2 = datas.authKwai.nickName
						// this.list[2].text2 = datas.authBili.nickName
						this.list[2].text2 = datas.userName
						this.list[3].text2 = datas.authXdsb.nickName
						this.list[4].text2 = datas.authCommerce.nickName
					}
				})
			},
			// 取消授权
			changeBinding(row){
				if(row.name == "zlqt"){
				   this.$alert('不可取消中链平台授权', '提示', {
					  confirmButtonText: '确定',
					});
				}else{
					this.$confirm('确定取消该授权信息，是否继续？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$axios.get(this.$store.state.VIDEO_URL+'/api/user/unbindAccount?userId='+this.$store.state.USER_ID+'&type='+row.name).then(res => {
							if (res.code == 1000) {
								this.$message({
									message: '取消授权成功',
									type: 'success'
								});
								this.getzt()
							}else{
								this.$message({
									message:res.data.message,
									type: 'error'
								});
							}
						})
					}).catch(() => {})
				}
				
			},
			// 绑定
			binding(id,title,name) {
				this.name = title
				if(id != "4" && id!= "5" && id != "6"){
					this.$axios.get(this.$store.state.VIDEO_URL+'/api/authorize/getAuthCode?userId='+this.$store.state.USER_ID+'&type='+name).then(data => {
						let datas = data.data
						if(data.code == "1000"){
							const newWindow = window.open(datas.url, undefined, "width='40%',height='40%',left=50,top=50")
							let that = this
							this.getSet = setInterval(function(){
								Axios.get(that.$store.state.VIDEO_URL+'/api/getAuthByType?userId='+that.$store.state.USER_ID+'&state='+data.data.state).then(res => {
								// Axios.post(this.$store.state.VIDEO_URL+'/api/getAuthByType?userId=').then(data => {
								// that.$axios.get(that.$store.state.VIDEO_URL+'/api/getAuthByType?userId='+that.$store.state.USER_ID+'&state='+data.data.state).then(res => {
									let resDate = res.data
									if(resDate.code == "200"){
										clearInterval(that.getSet)
										that.getzt()
										newWindow.close()
									}else if(resDate.code == "204"){
										if(newWindow.closed){
											clearInterval(that.getSet)
										}
									}else{
										clearInterval(that.getSet)
										that.$message.error(resDate.message);
									}
								})
							},1000)
							
							this.txtUrl = datas.url
						}
					})
				}else{
					this.dialogTab = true
					this.title = title
					this.name = name
					
				}
			},
			handleCloseB(){
				this.dialogTab=false
			},
			currentChange(size) {
				this.pagination.pageNumber = size
			},
			getVideList(){
				let postData = {
					userId:this.$store.state.USER_ID, //用户ID
					pageNumber:this.pagination.pageNumber, //分页
					pageSize: this.pagination.pageSize, //分页大小
					type:"", //kwai 快手、bili B站、tiktok抖音
					status:"", //发布状态
					title: "" ,//标题 支持模糊搜索
					page:this.page
				}
				Axios.post(this.$store.state.VIDEO_URL+'/api/getVideoList',JSON.parse(JSON.stringify(postData))).then(data => {
					let datas = data.data
					if(datas.code == "1000"){
						this.tableData = datas.data.list
						this.pagination = datas.data.page
					}
					
				})
				
			},
			handleJump(row){
				if(row.playList.kwai != null && row.playList.kwai != undefined){
					open(row.playList.kwai)
				}
				if(row.playList.tiktok != null && row.playList.tiktok != undefined){
					open(row.playList.tiktok)
				}
				if(row.playList.bili != null && row.playList.bili != undefined){
					open(row.playList.bili)
				}
				if(row.playList.zlqt != null && row.playList.zlqt != undefined){
					open(row.playList.zlqt)
				}
				if(row.playList.xdsb != null && row.playList.xdsb != undefined){
					open(row.playList.xdsb)
				}
				if(row.playList.hjwfsh != null && row.playList.hjwfsh != undefined){
					open(row.playList.hjwfsh)
				}
				
				// open(`${this.$store.state.ROOT_URL}/${row.path}.html`)
			},
			jumpVideo(){
				this.$router.push('/video/release')
			}
		},
	}
</script>
<style>
	.spText{
		font-size:16px;
	}
	.spListCount{
		display: flex;
		margin: 20px 0;
	}
	.spBoxs{
		width: 226px;
		height: 80px;
		margin: 0 20px;
		border: 1px dashed #d9d9d9;
		display: flex;
		justify-content: space-around;
		align-items: center;
	}
	.picBox{
		font-size:15px;
	}
	.picBox img {
		width: 32px;
		height: 32px;
		margin-right: 5px;
	}
	/* .spBoxs:nth-child(3) .picBox img {
		width: 100px;
	} */
	.spName{
		/* width:85px; */
		
	}
	.spName .name{
		width: 120px;
		height: 24px;
		line-height: 24px;
		text-align: left;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin:10px 0;
		font-size: 15px;
		color: #0194fe;
		font-weight: bold;
	}
	.changeBind{
		/* text-align: right; */
		cursor: pointer;
		color: #909399;
	}
	.dialogBox .title {
		text-align: center;
		font-size: 16px;
		font-weight: bold;
	}
	.el-input .el-input__inner{
		width: 300px !important;
	}
	.onBtn .el-form-item__content{
		margin: 0 auto;
		margin-left: 0 !important;
		text-align: center;
	}
	.forms{
		margin: 30px 0;
	}
	.submit-wrap{
		text-indent: 300px;
	}
	.el-form{
		margin-top: 20px !important;
	}
	.el-form-item{
		margin-bottom: 40px !important;
	}
	.avatar{
		width: 213px;
		height: 120px;
	}
	.cell .title{
		font-size: 15px !important;
		line-height: 30px;
		color: #333;
	}
	.cell .details{
		color: #999;
		line-height: 30px;
	}
	.xsqkBox .cell{
		display: flex !important;
	}
	.xsqkBox .cell span{
		margin-right: 5px !important;
	}
	.el-button+span {
		margin-left: 10px;
	}
	
	.el-pagination {
		text-align: center;
		margin-top: 20px;
	}
	
</style>